import { SourceControlProviderIcon } from "@/components/runners/details/SourceControlProviderIcon";
import type { PlainHostAuthenticationToken } from "@/queries/runner-configuration-queries";
import type { PlainRunner } from "@/queries/runner-queries";
import { hostAuthenticationTokenSourceLabel } from "@/utils/host-authentication-token-source";
import type { SCMIntegration } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";
import type { FC } from "react";

export type ServiceAccountGitAuthenticationDetailsProps = {
    token: PlainHostAuthenticationToken;
    runner?: PlainRunner;
    scmIntegration?: SCMIntegration;
};

export const ServiceAccountGitAuthenticationDetails: FC<ServiceAccountGitAuthenticationDetailsProps> = ({
    token,
    runner,
    scmIntegration,
}) => {
    return (
        <div className="flex gap-1">
            <div className="size-5 p-1">
                <SourceControlProviderIcon scmId={scmIntegration?.scmId} size="sm" />
            </div>
            <div className="flex flex-col">
                <span className="text-base font-medium text-content-primary">{runner?.name || "-"}</span>
                <div className="flex items-center gap-1">
                    <span className="text-sm text-content-primary">{token.host}</span>
                    <span className="text-sm text-content-inactive">•</span>
                    <span className="text-sm text-content-muted">
                        {hostAuthenticationTokenSourceLabel(token.source)}
                    </span>
                </div>
            </div>
        </div>
    );
};
